import React, { Component } from 'react'
import { withStyles, Card, CardHeader, Avatar, Typography, CardContent, Grid, TextField, FormControl, InputLabel, Select, OutlinedInput, MenuItem, CardActions, Button, IconButton, Chip } from '@material-ui/core';
import Add from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import Rich from './Rich';
import FileUpload from './FileUpload';
import { PostData, DeleteData } from '../../api/service';
import Snack from '../Snackbar/Snack';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const styles = theme => ({
  textField: {
    width: '100%'
  },
  formControl: {
    width: '100%',
    marginTop: theme.spacing.unit * 2
  },
  listCard: {
    marginTop: theme.spacing.unit * 3
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 12px',
    borderBottom: '1px solid #eef1f6',
  },
  rowNum: {
    width: 42,
    color: '#6b7a90',
    fontSize: '0.85rem',
    fontWeight: 700,
    textAlign: 'center',
  },
  rowMeta: {
    flexShrink: 0,
    width: 140,
    fontSize: '0.82rem',
    color: '#6b7a90',
  },
  rowTitle: {
    flex: 1,
    minWidth: 0,
    color: '#19375c',
    fontWeight: 600,
    fontSize: '0.94rem',
    wordBreak: 'break-word',
    paddingRight: 12,
  },
  rowPill: {
    flexShrink: 0,
    marginRight: 8,
  },
})

class AddNewContainer extends Component {

  state = {
    date: '',
    type: this.props.code,
    posted_as: '',
    title: '',
    description: '',
    uploadInfo: [],
    opening_date: '',
    closing_date: '',
    open: false,
    message: '',
    list: [],
    listLoaded: false,
  }

  __getInitialState() {
    this.setState({
      date: '',
      type: this.props.code,
      posted_as: '',
      title: '',
      description: '',
      uploadInfo: [],
      opening_date: '',
      closing_date: '',
    })
  }

  __loadType() {
    this.setState({
      type: this.props.code
    })
  }

  __loadList = () => {
    PostData(`/getnoticesbytype`, { type: this.props.code })
      .then((resp) => {
        this.setState({
          list: Array.isArray(resp) ? resp : [],
          listLoaded: true,
        })
      })
      .catch(() => this.setState({ listLoaded: true }))
  }

  componentDidMount() {
    this.__loadType();
    this.__loadList();
  }

  componentDidUpdate(prevProps) {
    if (this.props.code !== prevProps.code) {
      this.__loadType();
      this.__loadList();
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleRichChange = (data) => {
    this.setState({
      description: data
    })
  }

  onSetFile = (data) => {
    this.setState({
      uploadInfo: data
    })
  }

  onSubmit = (e) => {
    e.preventDefault();

    let data = {
      ...this.state
    }

    PostData(`/${this.props.apikey}/createnotice`, data)
      .then((resp) => {
        this.setState({
          open: true,
          message: resp
        })
      }).then(() => {
        this.__getInitialState();
        this.__loadList();
      })
  }

  onEditClick = (item) => {
    // EditNewContainer reads item data from history.location.state
    this.props.history.push('/edit', item);
  }

  onDeleteClick = (item) => {
    confirmAlert({
      title: 'Confirm delete',
      message: `Delete "${item.title || 'this item'}"?`,
      buttons: [
        { label: 'Yes, delete', onClick: () => this.onDeleteConfirm(item.id) },
        { label: 'Cancel' },
      ],
    });
  }

  onDeleteConfirm = (id) => {
    DeleteData(`/${this.props.apikey}/${id}/deletenotice`)
      .then((resp) => {
        this.setState({
          open: true,
          message: typeof resp === 'string' ? resp : 'Deleted',
        })
        this.__loadList();
      })
  }

  render() {
    let { classes } = this.props;

    let i = <Grid key={0} item lg={4} sm={12}>
      <TextField
        label="Opening Date"
        className={classes.textField}
        type="date"
        margin="normal"
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        name="opening_date"
        value={this.state.opening_date}
        onChange={this.handleChange}
      />
    </Grid>;

    let j = <Grid key={1} item lg={4} sm={12}>
      <TextField
        label="Closing Date"
        className={classes.textField}
        type="date"
        margin="normal"
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        name="closing_date"
        value={this.state.closing_date}
        onChange={this.handleChange}
      />
    </Grid>

    const list = this.state.list || [];

    return (
      <div>

        {this.state.open ?
          <Snack
            open={this.state.open}
            handleClose={() => {
              this.setState({
                open: false,
                message: ''
              })
            }}
            message={this.state.message}
          />
          : null}

        <form onSubmit={this.onSubmit}>
          <Card>
            <CardHeader
              avatar={<Avatar><Add /></Avatar>}
              title={
                <Typography variant="h6">
                  Add New {this.props.title}
                </Typography>
              }
            />
            <CardContent>
              <Grid container spacing={24}>
                <Grid item lg={4} sm={12}>
                  <TextField
                    label="Date"
                    className={classes.textField}
                    type="date"
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    required={true}
                    name="date"
                    value={this.state.date}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item lg={8} sm={12}>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel>Post As</InputLabel>
                    <Select
                      value={this.state.posted_as}
                      onChange={this.handleChange}
                      input={<OutlinedInput labelWidth={200} name="posted_as" />}
                      required={true}
                      name="posted_as"
                    >
                      <MenuItem value=""><em>None</em></MenuItem>
                      <MenuItem value="Kamakhya Ram Barooah Mahavidyalaya">Kamakhya Ram Barooah Mahavidyalaya</MenuItem>
                      <MenuItem value="Principal">Principal</MenuItem>
                      <MenuItem value="Student's Union">Student's Union</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {(this.props.code === 'tender' || this.props.code === 'events') ? [i, j] : null}

                <Grid item lg={12} sm={12}>
                  <TextField
                    label="Title"
                    className={classes.textField}
                    type="text"
                    margin="normal"
                    variant="outlined"
                    required={true}
                    name="title"
                    value={this.state.title}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item lg={12} sm={12}>
                  <Rich
                    placeholder="Description....."
                    onChange={this.handleRichChange}
                  />
                </Grid>

                <Grid item lg={12} sm={12}>
                  <FileUpload
                    dp={this.state.uploadInfo}
                    apikey={this.props.apikey}
                    type={this.props.code}
                    setDp={this.onSetFile.bind(this)}
                  />
                </Grid>
              </Grid>
            </CardContent>

            <CardActions>
              <Button variant="outlined" color="primary" type="submit">
                Submit
              </Button>
            </CardActions>
          </Card>
        </form>

        {/* LIST OF EXISTING ENTRIES OF THIS TYPE */}
        <Card className={classes.listCard}>
          <CardHeader
            title={
              <Typography variant="h6">
                Posted {this.props.title}
                {this.state.listLoaded ? (
                  <Chip
                    label={list.length}
                    size="small"
                    style={{ marginLeft: 12, background: '#eef2fb', color: '#19375c', fontWeight: 700 }}
                  />
                ) : null}
              </Typography>
            }
            subheader={`All ${this.props.title.toLowerCase()} entries submitted from this panel.`}
          />
          <CardContent style={{ paddingTop: 0 }}>
            {!this.state.listLoaded ? (
              <Typography color="textSecondary">Loading…</Typography>
            ) : list.length === 0 ? (
              <Typography color="textSecondary" style={{ fontStyle: 'italic' }}>
                No {this.props.title.toLowerCase()} posted yet.
              </Typography>
            ) : (
              <div>
                {list.map((el, index) => (
                  <div key={el.id || index} className={classes.row}>
                    <div className={classes.rowNum}>{index + 1}</div>
                    <div className={classes.rowMeta}>
                      {el.date_no ? `${el.date_no} ${el.month || ''} ${el.year || ''}` : (el.date || '—')}
                    </div>
                    <div className={classes.rowTitle}>{el.title || '—'}</div>
                    {el.posted_as ? (
                      <Chip
                        label={el.posted_as}
                        size="small"
                        className={classes.rowPill}
                        style={{ background: '#fff5e6', color: '#B8860B', fontWeight: 600 }}
                      />
                    ) : null}
                    <IconButton
                      onClick={() => this.onEditClick(el)}
                      title="Edit"
                    >
                      <EditIcon style={{ color: '#19375c' }} />
                    </IconButton>
                    <IconButton
                      onClick={() => this.onDeleteClick(el)}
                      title="Delete"
                    >
                      <DeleteIcon style={{ color: '#b71c1c' }} />
                    </IconButton>
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>

      </div>
    )
  }
}

export default withStyles(styles)(AddNewContainer)



// WEBPACK FOOTER //
// ./src/Components/AddNew/AddNewContainer.js